<script lang="ts" setup>
  import type { Component } from 'vue'

  defineProps<{
    icon?: Component | string
    text: string
  }>()
</script>

<template>
  <div class="c-chip">
    <component :is="icon" class="chip-icon" width="16px" />
    <span class="chip-text">{{ text }}</span>
  </div>
</template>

<style lang="scss" scoped>
  .c-chip {
    border: solid 1px var(--color-stroke-light);
    border-radius: 999px;

    display: inline-flex;
    flex-direction: row;
    gap: 8px;

    padding: 4px 12px;

    .chip-text {
      @include typography-body-small;
    }
  }
</style>
